import AccordionInnovation from "../../components/accordionInnovation";
import BannerProjects from "../../components/bannerProjects";
import BusinessOtimize from "../../components/businessOtimize";
import CardsFinops from "../../components/cardsFinops";
import FinopsBeneficios from "../../components/finopsBeneficios";
import Rodape from "../../components/rodape";

function Finops() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-finops.png"
                bgMobile="../assets/finops-mobile.png"
                title="/MIGRAÇÃO"
                titleBold={
                    <>
                        <span className="font-titillium-web-light">E</span>{" "}
                        FINOPS
                    </>
                }
                iconSrc="../assets/icone-projectiva-nex2ai.png"
                iconAlt="Projectiva Nex2AI"
                iconText="nex"
                iconTextBold="2ai"
                descriptionBold=""
                description={
                    <>
                        Com recursos para análise aprofundada, dashboards
                        intuitivos e recomendações personalizadas, tenha{" "}
                        <span className="font-titillium-web-bold">
                            total controle
                        </span>{" "}
                        para otimizar gastos e{" "}
                        <span className="font-titillium-web-bold">
                            maximizar o retorno.
                        </span>
                    </>
                }
                footerText="VERTICAL INNOVATION | Cloud"
                buttonText="Quero me conectar"
                buttonColor="from-[#FC0021] via-[#FC0021] to-[#5534D9]"
                brand="nex2ai"
            />
            <BusinessOtimize
                title={
                    <>
                        Colaboração que{" "}
                        <span className="font-inter-bold">
                            potencializa seu{" "}
                        </span>
                        <span className="font-inter-bold bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#4B3BDB] bg-clip-text text-transparent relative">
                            negócio{" "}
                        </span>
                        com otimização de custos e eficiência nos investimentos.
                    </>
                }
                buttonText="Otimize seu negócio"
                buttonTextColor="from-[#FC0021] via-[#FC0021] to-[#4B3BDB]"
                backgroundImage="../assets/cover-proposito.png"
                bgMobile="../assets/colaboracao-mobile.png"
                buttonLink="/"
            />
            <FinopsBeneficios
                cards={[
                    {
                        id: 1,
                        icon: "../assets/servicos/visibilidade_icon.svg",
                        title: "Visibilidade dos Custos",
                        text: "Com FinOps, tenha uma visão clara e completa dos investimentos em serviços na nuvem, identificando facilmente oportunidades de economia sem comprometer segurança e performance.",
                        glowColor: "#FC0021",
                    },
                    {
                        id: 2,
                        icon: "../assets/servicos/tomada_icon.svg",
                        title: "Tomada de Decisão Baseada em Dados",
                        text: "Decisões financeiras informadas que alinham as operações de nuvem com os objetivos de negócios.",
                        glowColor: "#FC0021",
                    },
                    {
                        id: 3,
                        icon: "../assets/servicos/otimizacao_icon.svg",
                        title: "Otimização de Recursos",
                        text: "Identificação de recursos ociosos ou subutilizados para otimizar o uso e reduzir despesas.",
                        glowColor: "#FC0021",
                    },
                ]}
            />
            <AccordionInnovation
                title={
                    <>
                        Práticas Chave
                        <br /> de FinOps
                    </>
                }
                description=""
                imageSrc="/assets/praticas-finops.png"
                imageAlt="Práticas FinOps"
                items={[
                    {
                        id: "01",
                        title: "ACOMPANHAMENTO CONTÍNUO",
                        description:
                            "Monitoramento em tempo real dos custos e uso de recursos na nuvem.",
                    },
                    {
                        id: "02",
                        title: "ALOCAÇÃO DE CUSTOS",
                        description:
                            "Distribuição precisa dos custos entre equipes e projetos.",
                    },
                    {
                        id: "03",
                        title: "AUTOMAÇÃO",
                        description:
                            "Ferramentas que automatizam a detecção de ineficiências e aplicam políticas de custo.",
                    },
                ]}
            />
            <div className="-mt-8 md:mt-0"></div>
            <AccordionInnovation
                title={
                    <>
                        Visibilidade e Controle
                        <br /> de Custos
                    </>
                }
                description="Com FinOps, sua empresa tem uma visão clara dos custos da nuvem, permitindo identificar onde economizar sem comprometer a performance."
                imageSrc="/assets/visibilidade-finops.png"
                items={[
                    {
                        id: "01",
                        title: "TRANSPARÊNCIA",
                        description:
                            "Clareza nos custos reais de cada serviço na nuvem.",
                    },
                    {
                        id: "02",
                        title: "RESPONSABILIDADE COMPARTILHADA",
                        description:
                            "TI e negócios com uma compreensão comum dos custos.",
                    },
                    {
                        id: "03",
                        title: "OPORTUNIDADES DE ECONOMIA",
                        description:
                            "Identificação rápida de onde economizar e reinvestir.",
                    },
                ]}
            />
            <CardsFinops
                title={
                    <>
                        <span className="font-inter-light">Otimização de </span>
                        <span className="bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#4B3BDB] bg-clip-text text-transparent">
                            Recursos
                        </span>
                    </>
                }
                description={
                    <>
                        FinOps otimiza o uso da nuvem, eliminando desperdícios e
                        garantindo a<br />
                        eficiência dos investimentos.
                    </>
                }
                cards={[
                    {
                        title: "Redimensionamento",
                        text: "Ajuste de recursos à demanda real.",
                        icon: "../assets/servicos/redimensionamento_icon.svg",
                        iconHover:
                            "../assets/servicos/redimensionamento_icon.svg",
                        glowColor: "#FC0021",
                    },
                    {
                        title: "Desligamento Automático",
                        text: "Desativação de recursos ociosos quando eles não são necessários.",
                        icon: "../assets/servicos/desligamento_icon.svg",
                        iconHover: "../assets/servicos/desligamento_icon.svg",
                        glowColor: "#FC0021",
                    },
                    {
                        title: "Compra Reservada",
                        text: "Uso de instâncias reservadas para economias significativas.",
                        icon: "../assets/servicos/compra_icon.svg",
                        iconHover: "../assets/servicos/compra_icon.svg",
                        glowColor: "#FC0021",
                    },
                ]}
            />
            <CardsFinops
                title={
                    <>
                        <span className="font-inter-light">
                            Decisões Financeiras{" "}
                        </span>
                        <span className="bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#4B3BDB] bg-clip-text text-transparent">
                            Informadas
                        </span>
                    </>
                }
                description={
                    <>
                        FinOps permite decisões financeiras baseadas em dados
                        precisos, alinhando estratégias de nuvem com objetivos
                        de negócios.
                    </>
                }
                cards={[
                    {
                        title: "Alinhamento Estratégico",
                        text: "Decisões que equilibram finanças e operações.",
                        icon: "../assets/servicos/alinhamento_icon.svg",
                        iconHover: "../assets/servicos/alinhamento_icon.svg",
                        glowColor: "#FC0021",
                    },
                    {
                        title: "Agilidade Financeira",
                        text: "Resposta rápida às mudanças de mercado.",
                        icon: "../assets/servicos/agilidade_financeira_icon.svg",
                        iconHover:
                            "../assets/servicos/agilidade_financeira_icon.svg",
                        glowColor: "#FC0021",
                    },
                    {
                        title: "Maximização do ROI",
                        text: "Melhor retorno sobre investimentos na nuvem.",
                        icon: "../assets/servicos/maximizacao_icon.svg",
                        iconHover: "../assets/servicos/maximizacao_icon.svg",
                        glowColor: "#FC0021",
                    },
                ]}
            />
            <Rodape />
        </>
    );
}

export default Finops;
